<template>
  <base-dialog :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="$t('notificationFilter.new_document')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('notificationFilter.new_document')}}</h2>
          <base-tooltip-icon size="sm" :content="extensionTooltipMessage" class="ml-2"/>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4">
        <el-form
          :model="form"
          :rules="newRules"
          ref="ruleForm"
        >
        <AccessibleElSelect
          v-if="showTipoDocumento"
          v-model="form.value"
          prop="value"
          :options="valuesForAccessibleSelect"
          :withFormItem="true"
          @visible-change="onExpand"
          @change="onChangeInput"
          id-prefix="notificationnewdocumentdialog"
        >
          <template slot="label">Tipo de documento</template>
        </AccessibleElSelect>
        <div 
          class="px-2 mb-2 lg:mb-0 "
          :class="[isLower1024 ? '' : 'center']">
          <el-form-item prop="file" ref="fileRef">
            <Upload
                role="button"
                ref="upload"
                id="fileSelector"
                class="bg-white dark:bg-darkblue-900"
                :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                drag
                multiple
                action="#"
                :auto-upload=false
                :on-progress="handleProgress"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :limit="this.maxFiles"
                :on-change="handleChange"
                :on-exceed="handleOnExceed"
                >
                <i class="el-icon-upload"></i>
                <p v-if="file.length" class="el-upload__text"><em>{{this.fileName}}</em></p>
                <div v-else class="el-upload__text">Suelta tus archivos aquí o <em>haz clic para cargar</em></div>
            </Upload>
          </el-form-item>
        </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button class="w-full" @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" :disabled="isGeneralLoading" :loading="isGeneralLoading"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="uploadNewDocument('ruleForm')" :disabled="disabledApply || isGeneralLoading" :loading="isGeneralLoading"/>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from './base/BaseDialog.vue'
import { Upload } from 'element-ui'
import { subirAnexo } from '@/services/notifications/subirAnexo'
import { i18n } from '@/i18n'
import { EXTENSIONES_ADJUNTOS } from '@/config/extensiones-adjuntos'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'notification-new-document-dialog',
  components: {
    BaseDialog,
    Upload,
    AccessibleElSelect
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    notification: {
      type: Number,
      default: -1
    },
    values: {
      type: Array,
      default: () => [],
    },
    showTipoDocumento: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      form: {
        notificationId: -1,
        value: '',
      },
      maxFiles: 15,
      extensionesAdjuntosPermitidas: EXTENSIONES_ADJUNTOS,
      file: [],
      newRules: {
        file: [
          {
            required: true,
            message: this.extensionRuleMessage,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              let invalidExtension = false
              this.file.forEach(archivo => {
                if (!this.extensionesAdjuntosPermitidas.includes(this.getExtensionFromFileName(archivo.name).toUpperCase())) {
                  invalidExtension = true
                }
              })
              if (invalidExtension) {
                this.doAriaLiveAndReturnCallback(this.extensionRuleMessage, callback)
              } else {
                callback()
              }
            }
          },
        ]
      }
      // file: {
      //   name: '',
      //   b64: ''
      // }
    }
  },
  mounted: async function () {
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    valuesForAccessibleSelect: function () {
      return this.values.map(item => ({
        id: item.id,
        name: item.value,
        value: item.id
      }))
    },
    hasModulePresentacionesAEAT () {
      return this.$store.getters['auth/hasModulePresentacionesAEAT']
    },
    extensionRuleMessage: function () {
      return i18n.t('validation.not_extension') + this.extensionesAdjuntosPermitidas.join(', ')
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    fileName () {
      if (this.file === null || this.file.length === 0) {
        return ''
      } else if (this.file.length === 1) {
        return this.file[0].name
      } else {
        return '(' + this.file.length + ') Archivos'
      }
    },
    disabledApply: function () {
      return this.file === undefined || this.file === null || this.file.length === 0
    },
    extensionTooltipMessage: function () {
      return 'Número máximo de ficheros: ' + this.maxFiles + '. ' +
      i18n.t('validation.extension') + this.extensionesAdjuntosPermitidas.join(', ')
    },
  },
  methods: {
    getExtensionFromFileName (fileName) {
      return fileName.split('.').at(-1)
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.file = []
      this.form.value = ''
      this.$emit('toggleDialog')
    },
    handleOnExceed: function () {
      this.doFeedback('Se ha superado el número máximo de ficheros (' + this.maxFiles + ')', 'warning')
    },
    handleChange: function (file) {
      this.$refs.fileRef.clearValidate()
      this.file.push(file)
    },
    handleRemove: function (file) {
      this.file = this.file.filter(x => x.uid !== file.uid)
    },
    handlePreview: function () {
    },
    handleProgress: function (e) {
    },
    uploadNewDocument: async function (formName) {
      this.$refs[formName].validate(async (valid) => {
        try {
          this.$store.commit('setIsLoading', true)
          if (valid) {
            const response = await subirAnexo(this.file, this.notification, this.form.value)
            if (response.blnError === true) {
              this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
            } else {
              this.$emit('applyDialog')
              this.doFeedback('Documentos añadidos correctamente', 'success')
              this.toggleDialog()
            }
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        } catch (error) {
          console.error(error)
          if (error.response?.data) {
            const errorText = await error.response.data
            this.doFeedback(errorText)
          } else {
            this.doFeedback()
          }
        } finally {
          // this.toggleDialog()
          this.$store.commit('setIsLoading', false)
        }
      })
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef.clientHeight
      }, 100)
    },
  }
}
</script>

<style lang="scss" scoped>
.center {
  margin: auto;
  width: 60%;
  border: none;
  padding: 1px;
}

</style>
